import { UrlType } from './constants';
import fly from './http';
function handleToken(urlType) {
  var _fly$config, _fly$config$extra;
  var accessToken = (_fly$config = fly.config) === null || _fly$config === void 0 ? void 0 : (_fly$config$extra = _fly$config.extra) === null || _fly$config$extra === void 0 ? void 0 : _fly$config$extra.accessToken;
  var opts = {
    headers: {
      urlType: urlType
    }
  };
  if (!!accessToken) {
    opts.headers['SUB-Access-Token'] = accessToken;
  }
  return opts;
}
/**
 * **接口** [ums银联支付↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-224-umspay-v2/interface/0a8f8dfba5a27f5ee5903a14a286dbee)
 * @请求头 `POST /api/bill/platform/sl/pay/umsPay/token`
 * @更新时间 `2023-01-05 18:55:34`
 */
export function postUmsPayToken(payload) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/umsPay/token", payload, opts);
}
/**
 * **接口** [ums银联支付确认↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-224-umspay-v2/interface/859237e835341ec63c1d3ad1b251da8d)
 * @请求头 `POST /api/bill/platform/sl/pay/umsPay/confirm`
 * @更新时间 `2023-01-05 18:55:34`
 */
export function postUMSPayConfirm(payload) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/umsPay/confirm", payload, opts);
}